// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:13:49.143Z
// Property: Park Plaza (ID: 6767906449167235)
// Collections: 10 amenities, 3 floorplans (live), 14 photos, 77 POIs, 2 reviews, 2 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167235",
  "property_external_id": "1101840",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/park-plaza/5XrgTX/",
  "property_apartments_url": "https://www.apartments.com/park-plaza-anchorage-ak/3hgrzmf/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+Plaza/data=!4m2!3m1!1s0x0:0xde4478467c15cacb?sa=X&ved=2ahUKEwjRn6C5loSTAxUG5ckDHVvdBBoQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47710856320",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-plaza",
  "property_name": "Park Plaza",
  "property_website_url": "https://www.parkplazaapartmenthomes.com",
  "property_domain": "https://www.parkplazaapartmenthomes.com",
  "property_address": "201 E 16th Ave",
  "property_full_address": "201 E 16th Ave, Anchorage, AK 99501",
  "property_address_1": "201 E 16th Ave",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99501",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "South Addition",
  "property_address_latitude": "61.20642989999999",
  "property_address_longitude": "-149.8805188",
  "property_email": "parkplaza@weidner.com",
  "property_phone": "(907) 308-5397",
  "property_call_tracking_phone": "907-308-5397",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Downtown Anchorage living made straightforward.</strong> Park Plaza pairs smoke-free studio, one-, and two-bedroom apartments with practical everyday convenience, comfortable layouts, and easy access to city energy and outdoor Anchorage—explore floor plans to find your next home base.</p>",
  "property_long_description": "<p><strong>Park Plaza puts downtown Anchorage, trail access, and everyday convenience within easy reach.</strong> Set in South Addition near the Delaney Park Strip, this smoke-free apartment community gives you a practical home base close to the Anchorage Museum, Fifth Avenue shopping, local restaurants, and the Tony Knowles Coastal Trail’s miles of shoreline views.</p><p>Choose from studio, one-bedroom, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with comfortable layouts, kitchens with dishwashers, ceiling fans, intercom/call-box entry, and generous closet space; select homes add walk-in closets, private balconies, and scenic views. With on-site management, laundry facilities, online payments and service requests, and 24-hour emergency maintenance, Park Plaza keeps daily living straightforward while placing you near the best of city energy and outdoor Anchorage. Explore the <a href=\"/amenities\">amenities</a>, then see more of the surrounding parks, dining, and trail connections on the <a href=\"/neighborhood\">neighborhood</a> page.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-408f-7109-b7c9-e96afb6c948e.webp",
  "property_featured_image_media": {
    "alt_text": "Interior view of a carpeted room with two open wooden doors, one leading to a closet and the other to a hallway with a bathroom visible.",
    "public_id": "01a08a00-408f-7109-b7c9-e96afb6c948e",
    "storage_key": "property/6767906449167235/01a08a00-408f-7109-b7c9-e96afb6c948e.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "111",
  "property_year_built": "1978",
  "property_year_renovated": null,
  "property_walk_score": "70",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.4954954954955",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Max 2 cats allowed; No weight limit for cats; Certified service dogs allowed; Other small pets (hamsters, birds, turtles, fish) allowed; maximum of 2 pets per household.",
  "property_pet_policy_description": "Max 2 Cats Allowed",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://parkplazaapartmenthomes.securecafe.com/onlineleasing/park-plaza-8/floorplans.aspx",
  "property_resident_portal_url": "https://parkplazaapartmenthomes.securecafenet.com/residentservices/park-plaza-8/userlogin",
  "property_apply_now_url": "https://parkplazaapartmenthomes.securecafe.com/onlineleasing/park-plaza-8/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ed9-3133-726c-a296-1685678c1aff.webp",
  "property_primary_logo_media": {
    "alt_text": "Park Plaza Apartment Homes logo",
    "public_id": "01a03ed9-3133-726c-a296-1685678c1aff",
    "storage_key": "property/6767906449167235/01a03ed9-3133-726c-a296-1685678c1aff.webp",
    "width": 97,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ed9-63f0-756e-a803-6223b27526c4.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03ed9-63f0-756e-a803-6223b27526c4",
    "storage_key": "property/6767906449167235/01a03ed9-63f0-756e-a803-6223b27526c4.webp",
    "width": 97,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ed9-55eb-7187-ae6b-a64f5d88d9da.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03ed9-55eb-7187-ae6b-a64f5d88d9da",
    "storage_key": "property/6767906449167235/01a03ed9-55eb-7187-ae6b-a64f5d88d9da.webp",
    "width": 97,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#a51e23",
  "property_secondary_color": "#571926",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d1ab9f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 611",
  "property_sqft_min": "506",
  "property_sqft_max": "611",
  "property_price_range": "855 - 1345",
  "property_price_min": "855",
  "property_price_max": "1345",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/ParkPlazaApartmentsAnchorage",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJq72GVs2XyFYRy8oVfEZ4RN4",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park Plaza",
  "property_home_romance_title": "Embrace a Life of Love in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Everyday essentials, right where you need them.</strong> Park Plaza keeps routines simple with on-site laundry, online payments and service requests, 24-hour emergency maintenance, and on-site property management. Apartments add practical comfort with dishwasher-equipped kitchens, intercom/call-box entry, smoke-free living, and organized closet space. Select homes also feature a private balcony, walk-in closet, ceiling fan, or Anchorage views.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the space that fits your day.</strong> Park Plaza offers studio, one-bedroom, and two-bedroom apartments in Anchorage with practical layouts, defined dining space, dishwasher-equipped kitchens, intercom entry, and generous closet storage. Select homes add extras like a private balcony, walk-in closet, ceiling fan, or views, giving you more to compare as you browse featured floor plans.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Park Plaza.</strong> Preview bright living spaces with balcony access, bedrooms with wide windows, and kitchens featuring warm wood cabinetry, full-size appliances, and a dishwasher. Exterior views highlight the low-rise building, mature greenery, balconies, and easy arrival from parking to the front entry—all set against Anchorage’s natural backdrop.</p>",
  "property_home_neighborhood_blurb": "<p><strong>South Addition puts Anchorage within easy reach.</strong> Step out from Park Plaza to Fire Island Rustic Bakeshop, New Sagaya City Market, the Chester Creek Greenbelt, and Westchester Lagoon. Downtown dining, arts, offices, and the Park Strip are nearby, giving everyday errands and outdoor time a connected rhythm. Explore the map to see what surrounds home.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the details at Park Plaza.</strong> Reviews call out helpful service, responsive support, and apartment features that stand out right away—from “lots of closet space” to deck views of the mountains. Residents also praise the updated community and “excellent customer service,” with Jordin and the team often mentioned for making tours, questions, and follow-ups feel easy.</p>",
  "property_neighborhood_blurb": "<p><strong>South Addition keeps Anchorage close and connected.</strong> From Park Plaza, you can move from neighborhood errands to outdoor time with ease: start with pastries from Fire Island Rustic Bakeshop, pick up fresh seafood and market staples at New Sagaya City Market, or follow the Chester Creek Greenbelt toward Westchester Lagoon and the city’s wider trail network. Downtown restaurants, arts, and offices are close by, while the Park Strip brings open green space and seasonal Anchorage energy just north of home. Use the map below to see how cafés, transit stops, parks, and everyday conveniences fit around your routine, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Park Plaza’s South Addition setting in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity essentials, built for easy routines.</strong> At Park Plaza, the details you use most are close at hand: on-site laundry, online payments and service requests, 24-hour emergency maintenance, and a property manager on site. Inside your apartment, everyday comfort comes through in a practical kitchen with a dishwasher, intercom/call-box entry, smoke-free living, and closet space that helps keep things organized.</p><p>Select homes add the features that make your space feel more connected to Anchorage, including a private balcony, walk-in closet, ceiling fan, or views. After you browse the full amenities below, explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Park Plaza fits your day-to-day.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Park Plaza home?</strong> Start your online application for a smoke-free downtown Anchorage apartment with comfortable layouts, generous closet space, and everyday conveniences that keep life simple—from online payments to 24-hour emergency maintenance.</p>",
  "property_contactus_blurb": "<p><strong>Have a question about Park Plaza?</strong> Reach out to the leasing team for details on availability, floor plans, community features, or directions to our South Addition location near downtown Anchorage. We’re here to help make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Park Plaza?</strong> Start here for quick answers about the community, leasing, floor plans, everyday conveniences, and what living here is like. If you need more details or want help with next steps, the leasing team is happy to connect.</p>",
  "property_floorplans_blurb": "<p><strong>Start with how you want your home to function.</strong> At Park Plaza, you can choose from streamlined studio, one-bedroom, and two-bedroom apartments in Anchorage, giving you options for a simpler setup, a little more separation, or extra room to spread out.</p><p>Each floor plan is designed around practical everyday comfort, with a kitchen that includes a dishwasher, defined dining space, intercom entry, and generous closet storage. Select homes add standout details like a private balcony, walk-in closet, ceiling fan, or views, so you can compare the features that matter most as you browse current pricing and availability. When you find a layout that fits, take a closer look at <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_gallery_blurb": "<p><strong>See Park Plaza room by room.</strong> The gallery brings the apartment experience into focus: a bright living area opening toward a balcony, bedrooms framed by wide windows, and kitchens with warm wood cabinetry, full-size appliances, and a dishwasher ready for everyday cleanup. Exterior photos show the low-rise building, balconies, mature greenery, and the simple arrival experience from the parking area to the front entry.</p><p>As you browse, notice the practical details that shape each space—soft carpeting, defined rooms, closet storage, and select views that connect your apartment to Anchorage’s natural backdrop. Compare what you see with the <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">apartment features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk through Park Plaza in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Park Plaza on the map.</strong> See available apartments in South Addition, then zoom out to place downtown Anchorage, nearby parks, local dining, shopping, and trail connections within easy reach from this practical home base near the Delaney Park Strip.</p>",
  "property_pets_blurb": "<p><strong>Room for the companions that make home feel complete.</strong> Park Plaza welcomes cats and select small pets, so your apartment can fit the everyday details that matter—sunny window perches, a quiet corner for a habitat, or space for a modest aquarium. Cat-friendly living pairs naturally with practical interiors like dishwasher-equipped kitchens, smoke-free homes, and select balconies or views; browse the full <a href=\"/amenities\">apartment features</a> to see what fits your routine.</p><p>When you want to talk through pet guidelines, small-pet options, or service-dog accommodations, the leasing team can help you understand the policy before you apply. Ready to see the spaces in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> and picture how you and your pets can settle in at Park Plaza.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at Park Plaza.</strong> If downtown Anchorage convenience, trail access, and comfortable layouts make everyday living easier, invite a friend to see it for themselves. Send a referral today and help someone you know find a straightforward home base near the city energy and outdoor Anchorage you already enjoy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Park Plaza.</strong> Pay rent online, submit service requests, and manage your account in one convenient place. With on-site management and 24-hour emergency maintenance, everyday apartment living stays straightforward.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate about Park Plaza.</strong> Reviews highlight a welcoming leasing experience, responsive support, and apartment features that make a memorable first impression. One reviewer praised the “lots of closet space” and mountain views from the deck, while another noted the updated community and “excellent customer service.”</p><p>From first tours to follow-up questions after move-out, residents call out Jordin and the team for being helpful, kind, and easy to work with. If you’re comparing apartments in South Addition, these reviews offer a real look at the service and details that help Park Plaza stand out.</p>",
  "property_created_at": "1771542812980",
  "property_scheduletour_blurb": "<p><strong>See Park Plaza in person.</strong> Tour comfortable studio, one-, and two-bedroom layouts with practical features like dishwashers, ceiling fans, generous closet space, and intercom entry. From downtown convenience to nearby trail access, it’s easy to picture everyday living here—schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Park Plaza.</strong><br>Your submission has been received, and the leasing team will follow up soon. In the meantime, picture comfortable downtown Anchorage living with practical floor plans, everyday convenience, and easy access to city energy and outdoor connections.</p>",
  "property_virtualtours_blurb": "At Park Plaza in Anchorage, AK, a variety of thoughtfully designed floor plans await you—from cozy studios to spacious two-bedroom apartments. Experience the perfect blend of comfort and style. Take a virtual tour of our vibrant community and let your ideal home come to life!",
  "property_copyright": "2026 All Rights Reserved. Park Plaza",
  "property_seo_title_home": "Park Plaza Apartments - Modern Living in Anchorage, AK",
  "property_seo_description_home": "Relaxed homes near Valley of the Moon Park and Chester Creek in Anchorage, AK, pet-friendly, with on-site parking and free 24-hour maintenance.",
  "property_seo_title_floorplans": "Floor Plans - Park Plaza Apartments in Anchorage, AK",
  "property_seo_description_floorplans": "Spacious studio, one, and two bedroom floor plans at Park Plaza in Anchorage, AK. Flexible layouts and details for your lifestyle.",
  "property_seo_title_amenities": "Amenities at Park Plaza Apartments in Anchorage, AK",
  "property_seo_description_amenities": "Experience convenient in-home and community amenities at Park Plaza in Anchorage, AK, including a dishwasher, storage, and on-site management.",
  "property_seo_title_gallery": "Photo Gallery - Park Plaza Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Browse the Park Plaza photo gallery for a closer look at comfortable homes, community spaces, and layouts in Anchorage, AK.",
  "property_seo_title_virtualtours": "Park Plaza Apartments Virtual Tour - Anchorage, AK",
  "property_seo_description_virtualtours": "Explore Park Plaza in Anchorage, AK online with a virtual tour. Picture layouts and lifestyle from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Park Plaza Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Park Plaza in Anchorage, AK! Explore modern floor plans and amenities with our interactive map today.",
  "property_seo_title_neighborhood": "Neighborhood Near Park Plaza Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Discover life near Valley of the Moon Park and local favorites in downtown Anchorage, AK. Live close to parks, dining, and city fun.",
  "property_seo_title_contact": "Contact Park Plaza Apartments in Anchorage, AK",
  "property_seo_description_contact": "Have questions about Park Plaza in Anchorage, AK? Contact our leasing team for details about your new home.",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Discover everything about Park Plaza in Anchorage, AK—floor plans, amenities, and more in our FAQs for your ideal apartment living!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Discover your ideal studio, one, or two-bedroom home at Park Plaza, Anchorage, AK! Join our vibrant community and read resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Experience modern living at Park Plaza in Anchorage, AK! Choose from spacious studios to 2-bedroom apartments with top amenities. Apply now for your new home!",
  "property_seo_title_residentaccess": "Resident Access | Park Plaza",
  "property_seo_description_residentaccess": "Login to Park Plaza’s resident portal—your hub for hassle-free rent payments, maintenance requests, and community updates in beautiful Anchorage, AK!",
  "property_seo_title_referafriend": "Refer A Friend | Park Plaza",
  "property_seo_description_referafriend": "Refer a friend to Park Plaza in Anchorage, AK! Great friends make great neighbors—share the warmth of community living today and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour of Park Plaza Apartments - Anchorage, AK",
  "property_seo_description_scheduletour": "Book your tour of Park Plaza in Anchorage, AK. Choose virtual or in-person options and see floor plans up close.",
  "property_seo_title_privacy": "Privacy Policy | Park Plaza",
  "property_seo_description_privacy": "At Park Plaza in Anchorage, AK, your privacy matters. Uncover our commitment to safeguarding your information. Dive into our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Park Plaza",
  "property_seo_description_accessibility": "Experience inclusive living at Park Plaza in Anchorage, AK. Our accessibility commitment ensures everyone finds comfort and community in every corner. Join us!",
  "property_seo_title_sitemap": "Sitemap | Park Plaza",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Park Plaza in Anchorage, AK. Check out our sitemap for an easy guide to all that our vibrant community offers!",
  "property_seo_title_thankyou": "Thank You | Park Plaza",
  "property_seo_description_thankyou": "Thank you for reaching out to Park Plaza! Our team will connect with you soon to help you find your perfect Anchorage home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791401963310",
  "amenities": [
    {
      "id": "ec_2f8ea53d86be16eabf668b7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87455998",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9385f4b069a69a8ed1655d42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87455993",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_497ad0561b88f8fbfa35e664",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87455996",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_214fc173f5d256e2a421e654",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "124799771",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fb08452cf6aa9e5d75f891a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87456000",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f3f157e64354c576cb88203",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87456002",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d9a3c-5b09-7499-b7eb-2c397c22e45b.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and countertops.",
        "public_id": "019d9a3c-5b09-7499-b7eb-2c397c22e45b",
        "storage_key": "property/6767906449167235/019d9a3c-5b09-7499-b7eb-2c397c22e45b.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Park Plaza Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ef098d98f568bd04e736eaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87456007",
      "title": "Private/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42f1f5ce8fe772812c738991",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87456005",
      "title": "Intercom/ Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa0673fbc2aba8996e36feec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87456008",
      "title": "Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f72c89b4883f677953900c99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "yardi",
      "external_id": "87456009",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_cbf0dd4cad61788993405b1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-408f-7109-b7c9-e96afb6c948e.webp",
      "image_media": {
        "alt_text": "Interior view of a carpeted room with two open wooden doors, one leading to a closet and the other to a hallway with a bathroom visible.",
        "public_id": "01a08a00-408f-7109-b7c9-e96afb6c948e",
        "storage_key": "property/6767906449167235/01a08a00-408f-7109-b7c9-e96afb6c948e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious interior featuring neutral carpeting and warm wood-toned doors. This room offers access to a closet and a hallway with a glimpse of the bathroom.",
      "link": "false",
      "alt_text": "Interior view of a carpeted room with two open wooden doors, one leading to a closet and the other to a hallway with a bathroom visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (27).JPG"
    },
    {
      "id": "ec_6ecaea891e9c6290b49efb9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-766c-7296-8c1e-2222bbfb0a92.webp",
      "image_media": {
        "alt_text": "Empty room with beige walls and carpet, a window overlooks a wooded area.",
        "public_id": "01a08a00-766c-7296-8c1e-2222bbfb0a92",
        "storage_key": "property/6767906449167235/01a08a00-766c-7296-8c1e-2222bbfb0a92.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty room features neutral beige walls and carpeting, with a large window offering views of the surrounding trees.",
      "link": "false",
      "alt_text": "Empty room with beige walls and carpet, a window overlooks a wooded area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (25).JPG"
    },
    {
      "id": "ec_5db444a160e172e6b9d19657",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-5e9a-74ca-b21f-57b0df663ce9.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet and a sliding glass door leading to a balcony.",
        "public_id": "01a08a00-5e9a-74ca-b21f-57b0df663ce9",
        "storage_key": "property/6767906449167235/01a08a00-5e9a-74ca-b21f-57b0df663ce9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy ample living space in this carpeted room, featuring a sliding glass door that opens to a private balcony, perfect for relaxation.",
      "link": "false",
      "alt_text": "Spacious living room with carpet and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (24).JPG"
    },
    {
      "id": "ec_5ead609448b179fc78e61425",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-61bf-7721-b47f-2190a48d3dc9.webp",
      "image_media": {
        "alt_text": "Kitchen with white stove, white refrigerator, and wood cabinets.",
        "public_id": "01a08a00-61bf-7721-b47f-2190a48d3dc9",
        "storage_key": "property/6767906449167235/01a08a00-61bf-7721-b47f-2190a48d3dc9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy preparing meals in this apartment kitchen, complete with a white stove and refrigerator, and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with white stove, white refrigerator, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (21).JPG"
    },
    {
      "id": "ec_e33c68f2a23c59428e000929",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-621a-707b-ae08-70d2fa9795a3.webp",
      "image_media": {
        "alt_text": "A kitchen with a white stove, white refrigerator, and wooden cabinets.",
        "public_id": "01a08a00-621a-707b-ae08-70d2fa9795a3",
        "storage_key": "property/6767906449167235/01a08a00-621a-707b-ae08-70d2fa9795a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A functional kitchen space featuring a white stove and refrigerator, complemented by wooden cabinetry and countertops.",
      "link": "false",
      "alt_text": "A kitchen with a white stove, white refrigerator, and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (20).JPG"
    },
    {
      "id": "ec_4215f71e973eb32535761624",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-61ba-759a-8f57-17b32d27a5a5.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and a breakfast bar.",
        "public_id": "01a08a00-61ba-759a-8f57-17b32d27a5a5",
        "storage_key": "property/6767906449167235/01a08a00-61ba-759a-8f57-17b32d27a5a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this charming kitchen, featuring ample wooden cabinetry and a convenient breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (19).JPG"
    },
    {
      "id": "ec_89e5a24dcba2746beda14cce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-9175-70ac-9163-9b9e4ad9ddb2.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "01a08a00-9175-70ac-9163-9b9e4ad9ddb2",
        "storage_key": "property/6767906449167235/01a08a00-9175-70ac-9163-9b9e4ad9ddb2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space, perfect for entertaining or unwinding after a long day. Features comfortable seating and a modern entertainment setup.",
      "link": "false",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (18).jpg"
    },
    {
      "id": "ec_6fad13c17f18ada865a4b646",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-94df-77af-af24-2738a72330cf.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with balconies and a parking lot.",
        "public_id": "01a08a00-94df-77af-af24-2738a72330cf",
        "storage_key": "property/6767906449167235/01a08a00-94df-77af-af24-2738a72330cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing the exterior of the apartment building, highlighting its architecture and the convenient parking facilities.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily apartment building with balconies and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (26).JPG"
    },
    {
      "id": "ec_dc701cfe0601fb29429511b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-9739-72ab-b587-5a29c3f14582.webp",
      "image_media": {
        "alt_text": "Park Plaza apartment building exterior with monument sign.",
        "public_id": "01a08a00-9739-72ab-b587-5a29c3f14582",
        "storage_key": "property/6767906449167235/01a08a00-9739-72ab-b587-5a29c3f14582.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the Park Plaza apartment building, showcasing its architecture and the property's monument sign.",
      "link": "false",
      "alt_text": "Park Plaza apartment building exterior with monument sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (23).JPG"
    },
    {
      "id": "ec_d7eb2bcace3c9183e4e65129",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-95b6-758b-afcf-389cea0cc45c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and blue patterned shower curtain.",
        "public_id": "01a08a00-95b6-758b-afcf-389cea0cc45c",
        "storage_key": "property/6767906449167235/01a08a00-95b6-758b-afcf-389cea0cc45c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a vanity with a sink, a toilet, and a vibrant blue and white patterned shower curtain.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, toilet, and blue patterned shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (17).jpg"
    },
    {
      "id": "ec_dac3dd1c24fa301f15bda6f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-992f-7279-a20a-c8a63f0482e3.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, stove, dishwasher, and dual sinks.",
        "public_id": "01a08a00-992f-7279-a20a-c8a63f0482e3",
        "storage_key": "property/6767906449167235/01a08a00-992f-7279-a20a-c8a63f0482e3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring a white refrigerator, electric stove, dishwasher, and a double basin sink with wooden cabinetry.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, stove, dishwasher, and dual sinks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (16).jpg"
    },
    {
      "id": "ec_c76b763176eeefa8606c7f8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-a48d-7519-b09d-4444bd0ded45.webp",
      "image_media": {
        "alt_text": "Fully furnished bedroom with a queen-size bed, nightstands, and a large window overlooking a wooded area.",
        "public_id": "01a08a00-a48d-7519-b09d-4444bd0ded45",
        "storage_key": "property/6767906449167235/01a08a00-a48d-7519-b09d-4444bd0ded45.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and a serene view of the surrounding nature.",
      "link": "false",
      "alt_text": "Fully furnished bedroom with a queen-size bed, nightstands, and a large window overlooking a wooded area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (15).jpg"
    },
    {
      "id": "ec_32dec0ad7ab36bae84317f98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-ac62-71c9-8799-fe8e3f9e23d9.webp",
      "image_media": {
        "alt_text": "Living room with carpet and view into kitchen and bathroom",
        "public_id": "01a08a00-ac62-71c9-8799-fe8e3f9e23d9",
        "storage_key": "property/6767906449167235/01a08a00-ac62-71c9-8799-fe8e3f9e23d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, adjacent to a functional kitchen and a clean bathroom. An ideal space for comfort and convenience.",
      "link": "false",
      "alt_text": "Living room with carpet and view into kitchen and bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (28).JPG"
    },
    {
      "id": "ec_453e7a947f40e094d610e642",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a08a00-abeb-721e-8fcd-a8c9f1a4fcd7.webp",
      "image_media": {
        "alt_text": "Park Plaza building exterior with signage and manicured landscaping.",
        "public_id": "01a08a00-abeb-721e-8fcd-a8c9f1a4fcd7",
        "storage_key": "property/6767906449167235/01a08a00-abeb-721e-8fcd-a8c9f1a4fcd7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The entrance to Park Plaza apartments features a welcoming sign, lush greenery, and accessible walkways.",
      "link": "false",
      "alt_text": "Park Plaza building exterior with signage and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Park-Plaza_Favorites (22).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6c0cf236-e083-410a-827f-84f0a0a54126",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-c42f-73fa-99e3-e84fdd06d210.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-c42f-73fa-99e3-e84fdd06d210",
        "storage_key": "property/6767906449167235/019d0226-c42f-73fa-99e3-e84fdd06d210.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4904-778e-b051-956a12337907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4904-778e-b051-956a12337907",
        "storage_key": "property/6767906449167235/019d0227-4904-778e-b051-956a12337907.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_73fc9998-39c8-4e2b-ab51-30a694b1e207",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-0d42-757e-9539-ef728bd30d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-0d42-757e-9539-ef728bd30d0c",
        "storage_key": "property/6767906449167235/01a03ec2-0d42-757e-9539-ef728bd30d0c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_e4f17cb3-dcee-46f8-8493-897ce43bb989",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Orso",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_long_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-c410-71b6-bb08-b56286b6513b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-c410-71b6-bb08-b56286b6513b",
        "storage_key": "property/6767906449167235/019d0226-c410-71b6-bb08-b56286b6513b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://orsoalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688852827403958754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orso",
      "poi_latitude": "61.2176833",
      "poi_longitude": "-149.8961662",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-222-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYR4rlzElC4dYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_1d0bffd4-d99a-4a8a-b14f-430e80d11f0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "49th State Brewing - Anchorage",
      "poi_type": "Restaurants",
      "poi_address": "717 W 3rd Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Lively brewpub with a rooftop patio doling out creative bar bites & housemade ales.",
      "poi_long_description": "Lively brewpub with a rooftop patio doling out creative bar bites & housemade ales.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec1-f809-7638-aebb-8fde1cb90b9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec1-f809-7638-aebb-8fde1cb90b9b",
        "storage_key": "property/6767906449167235/01a03ec1-f809-7638-aebb-8fde1cb90b9b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://49thstatebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5965183622877416450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "49th-state-brewing---anchorage",
      "poi_latitude": "61.21962659999999",
      "poi_longitude": "-149.8959168",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-277-7727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRhn_Ya9yFYRAgyWbeaWyFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_aaeeae1b-baaf-4bef-9cde-9bc87607e46d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Simon & Seafort's Saloon & Grill",
      "poi_type": "Restaurants",
      "poi_address": "420 L St, Anchorage, AK 99501, USA",
      "poi_short_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_long_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-c9e2-73c4-a9ab-af944a7c0496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-c9e2-73c4-a9ab-af944a7c0496",
        "storage_key": "property/6767906449167235/019d0226-c9e2-73c4-a9ab-af944a7c0496.webp",
        "width": 600,
        "height": 441
      },
      "poi_business_url": "https://www.simonandseaforts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1709221909627021300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simon--seaforts-saloon--grill",
      "poi_latitude": "61.2179842",
      "poi_longitude": "-149.9043854",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-274-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5_VXoG9yFYR9CeiXUVguBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d2cb8435-2ff2-48d4-a65c-682a3f9f120c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Crow's Nest",
      "poi_type": "Restaurants",
      "poi_address": "939 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "High-end restaurant offering French & New American cuisine, an extensive wine list & scenic views.",
      "poi_long_description": "High-end restaurant offering French & New American cuisine, an extensive wine list & scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-9ea2-741d-918a-d9fdd90da16d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-9ea2-741d-918a-d9fdd90da16d",
        "storage_key": "property/6767906449167235/01a03ec4-9ea2-741d-918a-d9fdd90da16d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.captaincook.com/dining/crows-nest",
      "poi_directions_map_url": "https://maps.google.com/?cid=3666166427093759864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crows-nest",
      "poi_latitude": "61.21777780000001",
      "poi_longitude": "-149.9",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-276-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUUNNIG9yFYRePdi9vDW4DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_4f7d2ae5-9e1a-4268-9e2c-7c34967e6097",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Humpy's Great Alaskan Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "610 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_long_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec1-e959-76dd-9038-5d1e9ac259a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec1-e959-76dd-9038-5d1e9ac259a1",
        "storage_key": "property/6767906449167235/01a03ec1-e959-76dd-9038-5d1e9ac259a1.webp",
        "width": 904,
        "height": 720
      },
      "poi_business_url": "https://www.humpysalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2859243613023281808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "humpys-great-alaskan-alehouse",
      "poi_latitude": "61.216342",
      "poi_longitude": "-149.894083",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-276-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14LWxYC9yFYRkKKOyOoSric",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_03c778cf-88a5-4e1a-9189-07e42c9fbcaa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "F Street Station",
      "poi_type": "Restaurants",
      "poi_address": "325 F St, Anchorage, AK 99501, USA",
      "poi_short_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_long_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a15e-735c-82be-8bad27b48efc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a15e-735c-82be-8bad27b48efc",
        "storage_key": "property/6767906449167235/01a03ec4-a15e-735c-82be-8bad27b48efc.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://fstreetstation.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=497107031803204211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f-street-station",
      "poi_latitude": "61.2189375",
      "poi_longitude": "-149.8931451",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-272-5196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtc6fbYe9yFYRc5L6LTYU5gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_5eae6b77-b3c9-445b-ac0e-33db6dbbbe88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Crush Wine Bistro & Cellar",
      "poi_type": "Restaurants",
      "poi_address": "328 G St, Anchorage, AK 99501, USA",
      "poi_short_description": "A huge variety of wines by the glass or bottle & shareable plates in an unpretentious atmosphere.",
      "poi_long_description": "A huge variety of wines by the glass or bottle & shareable plates in an unpretentious atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-9de2-714a-99ac-23a06ec2395b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-9de2-714a-99ac-23a06ec2395b",
        "storage_key": "property/6767906449167235/01a03ec4-9de2-714a-99ac-23a06ec2395b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.crushak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14560653215250281962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crush-wine-bistro--cellar",
      "poi_latitude": "61.218994",
      "poi_longitude": "-149.8957585",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-865-9198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyGVmSmWyFYR6nWkIPTUEco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_a0b1ed93-247b-41e0-abcf-0130c19a0cc7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Inlet PubHouse",
      "poi_type": "Restaurants",
      "poi_address": "1020 W 12th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Gourmet pub grub served in a casual setting at the Inlet Tower Hotel, with options for vegans.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-9cba-76cf-af83-438847a83b84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-9cba-76cf-af83-438847a83b84",
        "storage_key": "property/6767906449167235/01a03ec4-9cba-76cf-af83-438847a83b84.webp",
        "width": 1280,
        "height": 538
      },
      "poi_business_url": "https://www.inletpubhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10783396765056712240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inlet-pubhouse",
      "poi_latitude": "61.2101936",
      "poi_longitude": "-149.9026429",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-222-8787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN28G2X-9yFYRMD5NlTlSppU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_791d1dc4-8ab3-4617-9df4-7886af52af1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Sandwich Deck Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "400 K St, Anchorage, AK 99501, USA",
      "poi_short_description": "A chalkboard menu specializing in sandwiches & classic American fare for breakfast & lunch.",
      "poi_long_description": "A chalkboard menu specializing in sandwiches & classic American fare for breakfast & lunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a150-722e-a4e7-bceff9272977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a150-722e-a4e7-bceff9272977",
        "storage_key": "property/6767906449167235/01a03ec4-a150-722e-a4e7-bceff9272977.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sandwichdeck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12710318992180580269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandwich-deck-restaurant",
      "poi_latitude": "61.2183961",
      "poi_longitude": "-149.9018557",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-276-1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VAwT4G9yFYRrQ_T_scfZLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_1c441e14-72b0-404e-b430-ada21ab25971",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Club Paris",
      "poi_type": "Restaurants",
      "poi_address": "417 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Sizable cuts of aged beef & classic sides in a relaxed, family-owned institution with a full bar.",
      "poi_long_description": "Sizable cuts of aged beef & classic sides in a relaxed, family-owned institution with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a0a9-70f3-a69f-29cc4a1a7c48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a0a9-70f3-a69f-29cc4a1a7c48",
        "storage_key": "property/6767906449167235/01a03ec4-a0a9-70f3-a69f-29cc4a1a7c48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clubparisrestaurant.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6625737085512073237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-paris",
      "poi_latitude": "61.2176906",
      "poi_longitude": "-149.8902108",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-277-6332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJocFKwymWyFYRFUAUTcZY81s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_dd8232fc-d961-4338-85c3-183aadf1e6d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-ca29-737b-b046-aae968a6e12b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-ca29-737b-b046-aae968a6e12b",
        "storage_key": "property/6767906449167235/019d0226-ca29-737b-b046-aae968a6e12b.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fbabb033-914c-4daf-baef-e6e7f26965c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Sullivan's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "320 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Steakhouse chain serving beef, seafood & cocktails in swanky surrounds with live music.",
      "poi_long_description": "Steakhouse chain serving beef, seafood & cocktails in swanky surrounds with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-9e38-70ca-9423-600d6ad31778.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-9e38-70ca-9423-600d6ad31778",
        "storage_key": "property/6767906449167235/01a03ec4-9e38-70ca-9423-600d6ad31778.webp",
        "width": 1280,
        "height": 638
      },
      "poi_business_url": "https://sullivanssteakhouse.com/anchorage/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14639881408127896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivans-steakhouse",
      "poi_latitude": "61.21736999999999",
      "poi_longitude": "-149.88783",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-258-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0jnvSmWyFYRdQxPRZNOK8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_bdf0cfbd-cb30-431e-85ec-101838e1db95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Flattop Pizza + Pool",
      "poi_type": "Restaurants",
      "poi_address": "600 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Laid-back eatery & bar featuring a menu of pizza, pasta, craft beers & cocktails, plus pool tables.",
      "poi_long_description": "Laid-back eatery & bar featuring a menu of pizza, pasta, craft beers & cocktails, plus pool tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a0fc-726e-8ce4-c58006bc5448.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a0fc-726e-8ce4-c58006bc5448",
        "storage_key": "property/6767906449167235/01a03ec4-a0fc-726e-8ce4-c58006bc5448.webp",
        "width": 720,
        "height": 786
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11027347721897645431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flattop-pizza--pool",
      "poi_latitude": "61.216475",
      "poi_longitude": "-149.8937991",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-230-5423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-49b2-70e3-91d3-b49d69648681",
        "storage_key": "property/6767906449167235/019d0227-49b2-70e3-91d3-b49d69648681.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL6-TqoC9yFYRdxVs4lMCCZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a1394fea-8109-49af-bb57-9f59a20bfb2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "New Sagaya City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 W 13th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Local grocery store featuring fresh fish and seafood selections, plus a bakery and prepared foods bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a426-73bf-bb4b-b83248946a11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a426-73bf-bb4b-b83248946a11",
        "storage_key": "property/6767906449167235/01a03ec4-a426-73bf-bb4b-b83248946a11.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "https://newsagaya.com/locations/city-market/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10317338999052903724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-sagaya-city-market",
      "poi_latitude": "61.2093953",
      "poi_longitude": "-149.9004858",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-6173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4943-77bb-b56b-66d216fab5aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4943-77bb-b56b-66d216fab5aa",
        "storage_key": "property/6767906449167235/019d0227-4943-77bb-b56b-66d216fab5aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQBHqHmXyFYRLCXV8SeNLo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ef09757d-a986-4802-acb9-6115c81a2f6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Lucky Grocery & Deli",
      "poi_type": "Shopping & Retail",
      "poi_address": "326 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Convenience store and deli with sandwiches, groceries, and takeout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a432-7349-bef7-453daf4e8656.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a432-7349-bef7-453daf4e8656",
        "storage_key": "property/6767906449167235/01a03ec4-a432-7349-bef7-453daf4e8656.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13362409909371948115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-grocery--deli",
      "poi_latitude": "61.2183606",
      "poi_longitude": "-149.8886174",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-258-4877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-cf23-7204-832d-b7b27e48228a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ec4-cf23-7204-832d-b7b27e48228a",
        "storage_key": "property/6767906449167235/01a03ec4-cf23-7204-832d-b7b27e48228a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJxdDzzCmWyFYRU0xG9wPRcLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_ff12a917-9305-43ad-a824-8cd0873273ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage 5th Avenue Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "320 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec1-fde9-778b-b7a8-99e15faa13e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec1-fde9-778b-b7a8-99e15faa13e3",
        "storage_key": "property/6767906449167235/01a03ec1-fde9-778b-b7a8-99e15faa13e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/anchorage-5th-avenue-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=569891450485103965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-5th-avenue-mall",
      "poi_latitude": "61.2169618",
      "poi_longitude": "-149.888269",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-258-5535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH0jnvSmWyFYRXV2yOkGp6Ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_87b898a2-c667-442e-9e6e-c13115f0750a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Midnight Market | Vape And Smoke Shop in downtown Anchorage Alaska",
      "poi_type": "Shopping & Retail",
      "poi_address": "411 W 4th Ave D2, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a923-753c-84d7-e5651eccd3ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a923-753c-84d7-e5651eccd3ff",
        "storage_key": "property/6767906449167235/01a03ec4-a923-753c-84d7-e5651eccd3ff.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://midnightmarket.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2715313566612411403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midnight-market--vape-and-smoke-shop-in-downtown-anchorage-alaska",
      "poi_latitude": "61.2187914",
      "poi_longitude": "-149.889871",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-277-6653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA9xoMiiWyFYRC1S7b027riU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_efd4b94a-83cb-464e-bca5-addb6744e266",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Mint",
      "poi_type": "Shopping & Retail",
      "poi_address": "429 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Enduring retailer carrying house-minted medallions, estate jewelry, gold nuggets & timepieces.",
      "poi_long_description": "Enduring retailer carrying house-minted medallions, estate jewelry, gold nuggets & timepieces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-af79-74b8-a6c6-3c7db19d703a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-af79-74b8-a6c6-3c7db19d703a",
        "storage_key": "property/6767906449167235/01a03ec4-af79-74b8-a6c6-3c7db19d703a.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "http://www.alaskamint.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3359615894263172553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-mint",
      "poi_latitude": "61.218701",
      "poi_longitude": "-149.8904875",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-278-8414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXzv_1SmWyFYRyQ1QF9vAny4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "jewelry_store"
    },
    {
      "id": "custom_889255c8-aae4-4fcc-a4dc-def5eec35a33",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Fur Gallery",
      "poi_type": "Shopping & Retail",
      "poi_address": "428 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Long-running shop for jackets and coats, plus hats and gloves, made from fur by the family owners.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a6e7-75f7-a60f-1c120e289435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a6e7-75f7-a60f-1c120e289435",
        "storage_key": "property/6767906449167235/01a03ec4-a6e7-75f7-a60f-1c120e289435.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://alaskafurgallery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7334673499987183167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-fur-gallery",
      "poi_latitude": "61.2184057",
      "poi_longitude": "-149.8905475",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-274-3877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6eCw1ymWyFYRPwY1_q_-yWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_0c80f3d9-b0e6-468a-bc77-209e5e2a1404",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Skinny Raven Sports",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 H St, Anchorage, AK 99501, USA",
      "poi_short_description": "Specialty shop featuring footwear and gear for running, walking, and hiking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a714-77ab-9b28-3251e9bb88d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a714-77ab-9b28-3251e9bb88d2",
        "storage_key": "property/6767906449167235/01a03ec4-a714-77ab-9b28-3251e9bb88d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://skinnyraven.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15491915764224115290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skinny-raven-sports",
      "poi_latitude": "61.21434720000001",
      "poi_longitude": "-149.8979494",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJb6efYC9yFYRWkLa0E5X_tY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_4d8804d5-b660-4ec9-a9f5-401d3193386f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "10th & M Seafoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1020 M St, Anchorage, AK 99501, USA",
      "poi_short_description": "Market carrying fresh and frozen fish and seafood, plus dry ice and smoke-packed salmon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-ab1f-748c-b939-28c166767783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-ab1f-748c-b939-28c166767783",
        "storage_key": "property/6767906449167235/01a03ec4-ab1f-748c-b939-28c166767783.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.10thandmseafoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13193793552794792775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "10th--m-seafoods",
      "poi_latitude": "61.2122774",
      "poi_longitude": "-149.9064938",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-272-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlyJhnX-9yFYRRzMsIlXFGbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_3ab64187-f3b9-4cec-8b07-be292f22cdd5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3101 A St, Anchorage, AK 99503, USA",
      "poi_short_description": "Chain store selling a wide range of items from groceries and toys to electrical goods, and clothing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a80d-7590-9b93-d441967536d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a80d-7590-9b93-d441967536d1",
        "storage_key": "property/6767906449167235/01a03ec4-a80d-7590-9b93-d441967536d1.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2070-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4726814419269219339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.19226449999999",
      "poi_longitude": "-149.8802642",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-563-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOe6XNsaXyFYRC3S8q6sEmUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_95cc1b17-66d0-49e8-ba97-1e230b4c857d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "725 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a864-7589-b389-7b2d6015b78f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a864-7589-b389-7b2d6015b78f",
        "storage_key": "property/6767906449167235/01a03ec4-a864-7589-b389-7b2d6015b78f.webp",
        "width": 1213,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-725+e+northern+lights+blvd-anchorage-ak-99503/id=13656",
      "poi_directions_map_url": "https://maps.google.com/?cid=11830623915119265903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1959633",
      "poi_longitude": "-149.8686494",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-644-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmXnbSraXyFYRb8js-8TRLqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d0371dd6-2f08-477c-9755-1cec9aa40ef4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Central Middle School of Science",
      "poi_type": "Education",
      "poi_address": "1405 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-a9ee-752e-af40-f98ee8ea73b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-a9ee-752e-af40-f98ee8ea73b3",
        "storage_key": "property/6767906449167235/01a03ec4-a9ee-752e-af40-f98ee8ea73b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://central.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12980891005085165217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-middle-school-of-science",
      "poi_latitude": "61.2083004",
      "poi_longitude": "-149.8893498",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ9ZwCpOWyFYRoSYq6pdjJbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c812809b-be5a-41f1-a024-aedad6717ecf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "North Star Elementary School",
      "poi_type": "Education",
      "poi_address": "605 W Fireweed Ln, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-aa6f-77e9-8db2-780e0db0f45f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-aa6f-77e9-8db2-780e0db0f45f",
        "storage_key": "property/6767906449167235/01a03ec4-aa6f-77e9-8db2-780e0db0f45f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/northstar",
      "poi_directions_map_url": "https://maps.google.com/?cid=10574442937179307600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-elementary-school",
      "poi_latitude": "61.19960879999999",
      "poi_longitude": "-149.8942229",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC8iU0tGXyFYRUP41WNP3v5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8560217c-2d7f-42e6-83a4-f3e7c48fc27b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "West Anchorage High School",
      "poi_type": "Education",
      "poi_address": "1700 Hillcrest Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-af56-779f-8584-799af486ba86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-af56-779f-8584-799af486ba86",
        "storage_key": "property/6767906449167235/01a03ec4-af56-779f-8584-799af486ba86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://west.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15684090881757896505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-anchorage-high-school",
      "poi_latitude": "61.2007784",
      "poi_longitude": "-149.9166486",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeXfsf2K9yFYROV8fII8Vqdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_aa17dd9e-af17-4648-a818-e81bbed834b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec1-f6e3-739f-b9f8-bf4f17e8a777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec1-f6e3-739f-b9f8-bf4f17e8a777",
        "storage_key": "property/6767906449167235/01a03ec1-f6e3-739f-b9f8-bf4f17e8a777.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c223ccda-b52c-4677-aec9-502e9ef12a27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-eecc-72ac-a46d-773411914165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-eecc-72ac-a46d-773411914165",
        "storage_key": "property/6767906449167235/019d0226-eecc-72ac-a46d-773411914165.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8745f557-c8c9-47ea-893d-d0be364f9de6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Dr. Etheldra Davis Fairview Elementary",
      "poi_type": "Education",
      "poi_address": "1327 Nelchina St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-e5db-700f-a850-3ce0965718a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-e5db-700f-a850-3ce0965718a1",
        "storage_key": "property/6767906449167235/019d0226-e5db-700f-a850-3ce0965718a1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.asdk12.org/fairview",
      "poi_directions_map_url": "https://maps.google.com/?cid=12480516908653652287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-etheldra-davis-fairview-elementary",
      "poi_latitude": "61.21014100000001",
      "poi_longitude": "-149.8562484",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-742-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA-4FWjaWyFYRP6mO-QC0M60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_41a1100d-4f1e-4d59-96a1-be363f8bedb8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Government Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "525 E Bluff Dr, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/governmenthill",
      "poi_directions_map_url": "https://maps.google.com/?cid=14334643322608791820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-hill-elementary-school",
      "poi_latitude": "61.2333973",
      "poi_longitude": "-149.8707413",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJV8tVPW9yFYRDLEFWifi7sY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3dd5c1aa-223d-41d4-840b-e89da30ec730",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Inlet View Elementary School",
      "poi_type": "Education",
      "poi_address": "1219 N St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/inletview",
      "poi_directions_map_url": "https://maps.google.com/?cid=15879806796927077653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inlet-view-elementary-school",
      "poi_latitude": "61.2104006",
      "poi_longitude": "-149.9050422",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-7630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVUUNSn69yFYRFQ2soCVoYNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c9730fc4-fc41-4385-9b03-5fa6481d53cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Northern Lights Preschool & Child Care",
      "poi_type": "Education",
      "poi_address": "703 W Northern Lights Blvd Ste 200, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-abd0-743d-83d3-2d55185b610c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-abd0-743d-83d3-2d55185b610c",
        "storage_key": "property/6767906449167235/01a03ec4-abd0-743d-83d3-2d55185b610c.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "http://www.nlpkak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6040540510000710581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northern-lights-preschool--child-care",
      "poi_latitude": "61.195476",
      "poi_longitude": "-149.8967867",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-2040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJfvXzdqXyFYRtQPz9ZZP1FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_343e970c-1469-4479-92dc-d03411a1649b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Pacific Northern Academy",
      "poi_type": "Education",
      "poi_address": "2511 Sentry Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pacificnorthern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206734834740584442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-northern-academy",
      "poi_latitude": "61.1333745",
      "poi_longitude": "-149.8356213",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW969xGeWyFYR-l9pozx43gI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3387ab7d-4945-4884-97de-bdec9e920675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-0c7e-756d-8262-2460f213c118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-0c7e-756d-8262-2460f213c118",
        "storage_key": "property/6767906449167235/01a03ec2-0c7e-756d-8262-2460f213c118.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4ded-72a7-8ede-f258693344a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4ded-72a7-8ede-f258693344a8",
        "storage_key": "property/6767906449167235/019d0227-4ded-72a7-8ede-f258693344a8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a6030eab-532c-4b44-b19d-b45d854f81e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-f525-720b-8796-77804ac35757.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-f525-720b-8796-77804ac35757",
        "storage_key": "property/6767906449167235/019d0226-f525-720b-8796-77804ac35757.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1b3757f9-efc3-46e4-95e6-52e3ae7a8888",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "E Street Theater",
      "poi_type": "Entertainment",
      "poi_address": "315 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b15b-7617-9f40-fc67274306c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b15b-7617-9f40-fc67274306c3",
        "storage_key": "property/6767906449167235/01a03ec4-b15b-7617-9f40-fc67274306c3.webp",
        "width": 953,
        "height": 1280
      },
      "poi_business_url": "http://www.estreettheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11563790755098110231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-street-theater",
      "poi_latitude": "61.21905529999999",
      "poi_longitude": "-149.8911614",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-277-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-51ba-761f-b146-a7388755778a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-51ba-761f-b146-a7388755778a",
        "storage_key": "property/6767906449167235/019d0227-51ba-761f-b146-a7388755778a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SfTeIe9yFYRF6mRlmzWeqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_54b701ae-abdc-4857-a571-f696d8ed737d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Experience Theater",
      "poi_type": "Entertainment",
      "poi_address": "333 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9397382237278520003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-experience-theater",
      "poi_latitude": "61.218855",
      "poi_longitude": "-149.8885145",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-51ba-761f-b146-a7388755778a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-51ba-761f-b146-a7388755778a",
        "storage_key": "property/6767906449167235/019d0227-51ba-761f-b146-a7388755778a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZWUJQCXyFYRw0KN91o1aoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2ebc3a53-992b-4fc5-a16d-c51b021f770e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Cyrano's Theatre Company",
      "poi_type": "Entertainment",
      "poi_address": "3800 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Black-box theater staging a play a month, ranging from Shakespearean classics to original works.",
      "poi_long_description": "Black-box theater staging a play a month, ranging from Shakespearean classics to original works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b27e-75fe-9d72-06e808816296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b27e-75fe-9d72-06e808816296",
        "storage_key": "property/6767906449167235/01a03ec4-b27e-75fe-9d72-06e808816296.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.cyranos.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13374691035069826416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyranos-theatre-company",
      "poi_latitude": "61.2092959",
      "poi_longitude": "-149.8097145",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-274-2599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9JAzimWyFYRcEXwXaJynLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_212088ab-08d4-4627-b4c3-95a0d1207cf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage Weekend Downtown Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "225 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b296-7237-89bf-32f176dc38c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b296-7237-89bf-32f176dc38c7",
        "storage_key": "property/6767906449167235/01a03ec4-b296-7237-89bf-32f176dc38c7.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "https://awdmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1563121620173240437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-weekend-downtown-market",
      "poi_latitude": "61.2198326",
      "poi_longitude": "-149.8909675",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-306-9255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4dc7-75e7-af32-4a0f123b11d0",
        "storage_key": "property/6767906449167235/019d0227-4dc7-75e7-af32-4a0f123b11d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ-JaYa69yFYRdbgo79RSsRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_83916ab2-7a2e-445e-8bc5-f2563b6e5c06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b023-71f6-9715-74b445c19c2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b023-71f6-9715-74b445c19c2a",
        "storage_key": "property/6767906449167235/01a03ec4-b023-71f6-9715-74b445c19c2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-51ba-761f-b146-a7388755778a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-51ba-761f-b146-a7388755778a",
        "storage_key": "property/6767906449167235/019d0227-51ba-761f-b146-a7388755778a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7747447a-6ae7-4d0c-9024-ff52e5d45709",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-161e-74f8-b215-c5549127cd84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-161e-74f8-b215-c5549127cd84",
        "storage_key": "property/6767906449167235/01a03ec2-161e-74f8-b215-c5549127cd84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.9719066",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4ded-72a7-8ede-f258693344a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4ded-72a7-8ede-f258693344a8",
        "storage_key": "property/6767906449167235/019d0227-4ded-72a7-8ede-f258693344a8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f5bb6928-5ddd-4aca-a667-17503a59cb93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Dena’ina Civic and Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "600 W 7th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Located within the Dena'ina Civic and Convention Center, this facility hosts events such as conventions, concerts, and boat shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b368-7259-9174-9924e46f2660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b368-7259-9174-9924e46f2660",
        "storage_key": "property/6767906449167235/01a03ec4-b368-7259-9174-9924e46f2660.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://denaina.anchorageconventioncenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13102333279014608095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denaina-civic-and-convention-center",
      "poi_latitude": "61.2154727",
      "poi_longitude": "-149.8946224",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-263-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaMkCiqWyFYR39xxuLLW1LU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_6eb4f738-8ab8-45c8-a73c-48bf54e6f31b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-4714-716f-b23b-1874dc04672c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-4714-716f-b23b-1874dc04672c",
        "storage_key": "property/6767906449167235/01a03ec2-4714-716f-b23b-1874dc04672c.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5216-745a-b9eb-96a279a84c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5216-745a-b9eb-96a279a84c4f",
        "storage_key": "property/6767906449167235/019d0227-5216-745a-b9eb-96a279a84c4f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_3b257fd2-c109-4df7-a3a6-bbfeb28bac99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Providence Urgent Care - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 W Northern Lights Blvd B, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b48a-7135-b10e-74443dffafa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b48a-7135-b10e-74443dffafa3",
        "storage_key": "property/6767906449167235/01a03ec4-b48a-7135-b10e-74443dffafa3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/urgent-care-midtown?Is=location&y_source=1_MzAxNTI2NzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16999347318438363632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-urgent-care---midtown",
      "poi_latitude": "61.1952149",
      "poi_longitude": "-149.9066709",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-212-5165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL90jWz6XyFYR8AEC2VHQ6es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6b87a6d8-89f2-4157-b8b4-14d550e90cd7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2920 Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-d695-70ad-9f55-5fa27ec0a602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-d695-70ad-9f55-5fa27ec0a602",
        "storage_key": "property/6767906449167235/019d0226-d695-70ad-9f55-5fa27ec0a602.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/2920-seward-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3884467756580912231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.19401339999999",
      "poi_longitude": "-149.8639713",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-339-0660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-52ce-7361-b94d-490754f2af79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-52ce-7361-b94d-490754f2af79",
        "storage_key": "property/6767906449167235/019d0227-52ce-7361-b94d-490754f2af79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSfl-SiXyFYRZ7x2BNhm6DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_52ac04c0-20bf-42cb-bc8c-fded687be101",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage Pioneer Home",
      "poi_type": "Health and Wellness",
      "poi_address": "923 W 11th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b671-772d-b24e-5f5b895d6dcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b671-772d-b24e-5f5b895d6dcf",
        "storage_key": "property/6767906449167235/01a03ec4-b671-772d-b24e-5f5b895d6dcf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dfcs.alaska.gov/daph/pages/anchorage/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4857453532742240900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-pioneer-home",
      "poi_latitude": "61.21213840000001",
      "poi_longitude": "-149.9004959",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-276-3414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-L2gWm9yFYRhEoRjEAkaUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_b1a65003-1886-463e-8bd6-38a5a75dff16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "The Alaska Club Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "701 W 8th Ave Ste 100, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-05eb-714f-ac6f-08883dd2a64d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-05eb-714f-ac6f-08883dd2a64d",
        "storage_key": "property/6767906449167235/019d0227-05eb-714f-ac6f-08883dd2a64d.webp",
        "width": 537,
        "height": 411
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacdt-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=9293149657447986627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-downtown",
      "poi_latitude": "61.21480699999999",
      "poi_longitude": "-149.8973812",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-4232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxe52Ia9yFYRw_W6UGDm94A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_89a6f7bf-25c0-49f3-b6ec-a80f77230068",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Namaste North Yoga and Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "400 L St Ste 150, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b7a8-73b3-add6-2a93c1ae8864.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b7a8-73b3-add6-2a93c1ae8864",
        "storage_key": "property/6767906449167235/01a03ec4-b7a8-73b3-add6-2a93c1ae8864.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://namastenorthak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9069125572253388481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "namaste-north-yoga-and-wellness",
      "poi_latitude": "61.2183678",
      "poi_longitude": "-149.9044142",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-277-2256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn2U2vYe9yFYRwQ6TXagB3H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9a772e17-16c6-4e0f-955b-350c43a1357a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "670 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Workout center chain in Midtown Mall with updated equipment, free weights, and tanning services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-2c20-749e-9e7e-82e39f04be2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-2c20-749e-9e7e-82e39f04be2d",
        "storage_key": "property/6767906449167235/01a03ec2-2c20-749e-9e7e-82e39f04be2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/anchorage-northern-lights-blvd-ak?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11613855461750134227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "61.19478189999999",
      "poi_longitude": "-149.8719043",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-444-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSjXk7eXyFYR09VYdgK0LKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_73b462fd-3edd-4ae0-804b-7b5f49e2a33d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Rock Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "665 E 33rd Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Indoor rock climbing gym offering programs for adults & kids, plus fitness classes.",
      "poi_long_description": "Indoor rock climbing gym offering programs for adults & kids, plus fitness classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-b8d0-73ba-9315-5c9c176259ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-b8d0-73ba-9315-5c9c176259ab",
        "storage_key": "property/6767906449167235/01a03ec4-b8d0-73ba-9315-5c9c176259ab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.alaskarockgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15802851744102552212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-rock-gym",
      "poi_latitude": "61.19129030000001",
      "poi_longitude": "-149.8710874",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-562-7265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1_7o5eXyFYRlBJlJe8BT9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_6cd114d5-2467-4721-bfb8-9bf18fe5ffea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-1550-737d-81af-62781729df3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-1550-737d-81af-62781729df3a",
        "storage_key": "property/6767906449167235/019d0227-1550-737d-81af-62781729df3a.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5216-745a-b9eb-96a279a84c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5216-745a-b9eb-96a279a84c4f",
        "storage_key": "property/6767906449167235/019d0227-5216-745a-b9eb-96a279a84c4f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_961a5275-351f-4a15-ab13-8cdf2f05a7b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Adagio Day Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "404 K St, Anchorage, AK 99501, USA",
      "poi_short_description": "Day spa offering massage, facials, and other services such as pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-ba5b-7334-893d-5ae6a8d95b1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-ba5b-7334-893d-5ae6a8d95b1f",
        "storage_key": "property/6767906449167235/01a03ec4-ba5b-7334-893d-5ae6a8d95b1f.webp",
        "width": 1280,
        "height": 986
      },
      "poi_business_url": "https://www.adagio-spa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9513734426004205110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adagio-day-spa",
      "poi_latitude": "61.2183265",
      "poi_longitude": "-149.9018336",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-222-3601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ67m7TIG9yFYRNq5i9Q2TB4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spa"
    },
    {
      "id": "custom_4eb1187e-4f6f-4ee5-a4c1-652eab738998",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Delaney Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 9th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Big park with sports fields, tennis courts & horseshoe pits, plus an ice-hockey rink & skating area.",
      "poi_long_description": "Big park with sports fields, tennis courts & horseshoe pits, plus an ice-hockey rink & skating area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-2544-7016-a080-8308da344ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-2544-7016-a080-8308da344ca9",
        "storage_key": "property/6767906449167235/019d0227-2544-7016-a080-8308da344ca9.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "http://muni.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1290405951593808698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaney-park",
      "poi_latitude": "61.213055",
      "poi_longitude": "-149.896227",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QWeniqWyFYROoPMSGBx6BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_84622b8a-45d7-422c-85d9-5b67bfa79a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Valley of the Moon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "610 W 17th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Tree-lined green space with a large, modern playground, dog park, hiking trails & a creek.",
      "poi_long_description": "Tree-lined green space with a large, modern playground, dog park, hiking trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-664c-765e-9bb9-7bdcc67c91df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-664c-765e-9bb9-7bdcc67c91df",
        "storage_key": "property/6767906449167235/01a03ec2-664c-765e-9bb9-7bdcc67c91df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaska.org/detail/valley-of-the-moon-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13618989538806419726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-of-the-moon-park",
      "poi_latitude": "61.2049461",
      "poi_longitude": "-149.8945141",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0Huw9OXyFYRDlFRPNReAL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_57207216-b303-4d9b-aeec-7c7320c9ecb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Town Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "544 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Small park featuring flowers & concerts in the summer, plus ice sculptures & a rink in the winter.",
      "poi_long_description": "Small park featuring flowers & concerts in the summer, plus ice sculptures & a rink in the winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-bd7d-724f-86b2-a8294798fa52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-bd7d-724f-86b2-a8294798fa52",
        "storage_key": "property/6767906449167235/01a03ec4-bd7d-724f-86b2-a8294798fa52.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12145788217067135527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-square-park",
      "poi_latitude": "61.217028",
      "poi_longitude": "-149.892606",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIytn_SmWyFYRJ2JpQwiCjqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_a4b80670-b986-4b64-9a8a-5edeeba1db34",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Buttress Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "128 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-ba90-7453-b887-1c37c7806ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-ba90-7453-b887-1c37c7806ca9",
        "storage_key": "property/6767906449167235/01a03ec4-ba90-7453-b887-1c37c7806ca9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2666424950562272122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buttress-park",
      "poi_latitude": "61.22055839999999",
      "poi_longitude": "-149.8851453",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlb2Z9RaXyFYRerOAfl0LASU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e867f896-3a95-4d97-a54e-9bd680286dee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Railroad Corporation",
      "poi_type": "Transportation & Transit",
      "poi_address": "327 W Ship Creek Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-bb27-732f-b758-85d1156d0649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-bb27-732f-b758-85d1156d0649",
        "storage_key": "property/6767906449167235/01a03ec4-bb27-732f-b758-85d1156d0649.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "https://www.alaskarailroad.com/corporate",
      "poi_directions_map_url": "https://maps.google.com/?cid=13146147969309211409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-railroad-corporation",
      "poi_latitude": "61.22278739999999",
      "poi_longitude": "-149.8881884",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-265-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbzebYi9yFYREftlQ-1_cLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_be0411dd-6f0f-452d-bab4-c3b0a0f7a089",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Margaret Eagan Sullivan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1824 W 15th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_long_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-bb8a-761b-9da4-d8747a7a6875.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-bb8a-761b-9da4-d8747a7a6875",
        "storage_key": "property/6767906449167235/01a03ec4-bb8a-761b-9da4-d8747a7a6875.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10765612440412588611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "margaret-eagan-sullivan-park",
      "poi_latitude": "61.20760069999999",
      "poi_longitude": "-149.9170951",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwm4bXy9yFYRQ4pR1HkjZ5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_1cb9b80b-5065-47b0-83b1-82a925b68c1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Earthquake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5101 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_long_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-5aea-71c2-8f6e-49579471b762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-5aea-71c2-8f6e-49579471b762",
        "storage_key": "property/6767906449167235/01a03ec2-5aea-71c2-8f6e-49579471b762.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.anchorage.net/discover/trails-and-local-parks/earthquake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10919572690925706311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earthquake-park",
      "poi_latitude": "61.1984068",
      "poi_longitude": "-149.9802084",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2AwokC9yFYRR9yuDYIdipc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_097758f5-9ff9-4607-8bc4-8b721aa9da1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Kincaid Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_long_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-bd0c-719b-894f-785bbdf9f68e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-bd0c-719b-894f-785bbdf9f68e",
        "storage_key": "property/6767906449167235/01a03ec4-bd0c-719b-894f-785bbdf9f68e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15637430419620688250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-park",
      "poi_latitude": "61.1536409",
      "poi_longitude": "-150.05538",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxF8gvOiyFYRevFgsR1QA9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f3e5914a-0d5f-42e3-9d52-1c8238f417b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Frontierland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "538 W 10th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c2ae-72b8-b756-50d7a5210505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c2ae-72b8-b756-50d7a5210505",
        "storage_key": "property/6767906449167235/01a03ec4-c2ae-72b8-b756-50d7a5210505.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9969154455228181551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frontierland-park",
      "poi_latitude": "61.2126095",
      "poi_longitude": "-149.8921414",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5214-723c-922e-acee90d2d4d0",
        "storage_key": "property/6767906449167235/019d0227-5214-723c-922e-acee90d2d4d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUf_ASuWyFYRL-zgfiiNWYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_89c31ce7-fdc1-4b2f-996f-1b979c5f1da5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-bf0a-7328-a8c5-3e68b5aae57b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-bf0a-7328-a8c5-3e68b5aae57b",
        "storage_key": "property/6767906449167235/01a03ec4-bf0a-7328-a8c5-3e68b5aae57b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_100a8804-636a-4f01-89d1-daf3138edc5e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-6b55-7089-a21a-af9fde15b638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-6b55-7089-a21a-af9fde15b638",
        "storage_key": "property/6767906449167235/01a03ec2-6b55-7089-a21a-af9fde15b638.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.22168490000001",
      "poi_longitude": "-149.8904657",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5677-70c9-ba74-7c6bdcfb3422.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5677-70c9-ba74-7c6bdcfb3422",
        "storage_key": "property/6767906449167235/019d0227-5677-70c9-ba74-7c6bdcfb3422.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_673ba05c-be04-43da-be90-7598fec154ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Port Of Alaska",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 Anchorage Port Rd, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c256-728e-acc8-f2a93ac827b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c256-728e-acc8-f2a93ac827b3",
        "storage_key": "property/6767906449167235/01a03ec4-c256-728e-acc8-f2a93ac827b3.webp",
        "width": 952,
        "height": 984
      },
      "poi_business_url": "http://www.portofalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615135989646056101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-alaska",
      "poi_latitude": "61.2393502",
      "poi_longitude": "-149.8880141",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ec4-cf2c-7340-ad8c-3b133f27961e",
        "storage_key": "property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJORWui_K9yFYRpVrNDqAdahY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_4e29fa11-abed-4e31-8e89-3c0d499551c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Merrill Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 Merrill Field Dr, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-3844-72f7-8654-71513d77f8e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-3844-72f7-8654-71513d77f8e3",
        "storage_key": "property/6767906449167235/019d0227-3844-72f7-8654-71513d77f8e3.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.muni.org/Departments/merrill_field/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3690256857556359428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merrill-field-airport",
      "poi_latitude": "61.215917",
      "poi_longitude": "-149.8419312",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-6303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-56f5-762f-85de-61177b9dd7b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-56f5-762f-85de-61177b9dd7b5",
        "storage_key": "property/6767906449167235/019d0227-56f5-762f-85de-61177b9dd7b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1chpUeWyFYRBJmYZA9tNjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_cb3ab7e9-be62-453c-b232-b325ad79cc40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-7454-74bb-81f5-9e6849af7d54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-7454-74bb-81f5-9e6849af7d54",
        "storage_key": "property/6767906449167235/01a03ec2-7454-74bb-81f5-9e6849af7d54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-56f5-762f-85de-61177b9dd7b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-56f5-762f-85de-61177b9dd7b5",
        "storage_key": "property/6767906449167235/019d0227-56f5-762f-85de-61177b9dd7b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_5bf9b915-6dee-412a-92ce-95c6c7a0c2a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c3ae-70fd-a672-733195ea43aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c3ae-70fd-a672-733195ea43aa",
        "storage_key": "property/6767906449167235/01a03ec4-c3ae-70fd-a672-733195ea43aa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ec4-cf2c-7340-ad8c-3b133f27961e",
        "storage_key": "property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_7a66d1c1-79ee-4600-802e-6c87f8904924",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Muldoon & 16th Avenue NNE",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13770519895911066392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muldoon--16th-avenue-nne",
      "poi_latitude": "61.207688",
      "poi_longitude": "-149.733186",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ec4-cf2c-7340-ad8c-3b133f27961e",
        "storage_key": "property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYvZobyWyFYRGGs60OK2Gr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_76e30bdc-ca68-46c6-9083-84820767f444",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Eagle River Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99577, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c6e0-75c8-b9a1-645efade7271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c6e0-75c8-b9a1-645efade7271",
        "storage_key": "property/6767906449167235/01a03ec4-c6e0-75c8-b9a1-645efade7271.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5293723384036886587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagle-river-transit-center",
      "poi_latitude": "61.32776500000001",
      "poi_longitude": "-149.573677",
      "poi_miles_from_property": "15.9",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ec4-cf2c-7340-ad8c-3b133f27961e",
        "storage_key": "property/6767906449167235/01a03ec4-cf2c-7340-ad8c-3b133f27961e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJb--R-XLryFYRO4iy1F4Vd0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_068f9d2b-4024-4175-93bf-623ca5cdfeed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-41e8-7070-ad32-e45e58c0c5c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-41e8-7070-ad32-e45e58c0c5c0",
        "storage_key": "property/6767906449167235/019d0227-41e8-7070-ad32-e45e58c0c5c0.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_7cdff45a-d828-496f-83a7-ef4336040c9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Southcentral Foundation Nu ch’ghednu Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Southcentral Foundation Administration Building, 4501 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c549-7750-9c15-a018e1e1cf19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c549-7750-9c15-a018e1e1cf19",
        "storage_key": "property/6767906449167235/01a03ec4-c549-7750-9c15-a018e1e1cf19.webp",
        "width": 1022,
        "height": 1280
      },
      "poi_business_url": "https://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17022574653971337258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation-nu-chghednu-building",
      "poi_latitude": "61.18234169999999",
      "poi_longitude": "-149.795892",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-729-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYTXMhyXyFYRKpCHVHVVPOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cb9b1602-c3bd-4904-af05-a91e0a8dc5e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-0781-734a-b9c6-0498b8d71aa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-0781-734a-b9c6-0498b8d71aa7",
        "storage_key": "property/6767906449167235/019d0227-0781-734a-b9c6-0498b8d71aa7.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.20017319999999",
      "poi_longitude": "-149.8222317",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-5216-745a-b9eb-96a279a84c4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-5216-745a-b9eb-96a279a84c4f",
        "storage_key": "property/6767906449167235/019d0227-5216-745a-b9eb-96a279a84c4f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a37d8680-43f2-4ade-bd4b-c0821ea3ce02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c6d0-77fb-b9b0-a849cb860073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c6d0-77fb-b9b0-a849cb860073",
        "storage_key": "property/6767906449167235/01a03ec4-c6d0-77fb-b9b0-a849cb860073.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.1939631",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4df7-77f8-a24a-20e57ea333fc",
        "storage_key": "property/6767906449167235/019d0227-4df7-77f8-a24a-20e57ea333fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_858cd0dc-68f8-4041-96a0-caae75a1b4d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec2-6f3a-7331-99ed-7061d6086fc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec2-6f3a-7331-99ed-7061d6086fc0",
        "storage_key": "property/6767906449167235/01a03ec2-6f3a-7331-99ed-7061d6086fc0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.21632990000001",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-56fb-755f-b26a-326400d74287.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-56fb-755f-b26a-326400d74287",
        "storage_key": "property/6767906449167235/019d0227-56fb-755f-b26a-326400d74287.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f7135f75-6ebe-47ed-b129-bf04f8f0b08a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "poi_name": "James M. Fitzgerald United States Courthouse and Federal Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "222 W 7th Ave, Anchorage, AK 99513, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ec4-c9f8-709c-94d0-8eff359318ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ec4-c9f8-709c-94d0-8eff359318ee",
        "storage_key": "property/6767906449167235/01a03ec4-c9f8-709c-94d0-8eff359318ee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.akd.uscourts.gov/content/anchorage",
      "poi_directions_map_url": "https://maps.google.com/?cid=17474383984590163259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-m-fitzgerald-united-states-courthouse-and-federal-building",
      "poi_latitude": "61.2150018",
      "poi_longitude": "-149.8853591",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-677-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-4e4c-758e-934d-2169087524ae",
        "storage_key": "property/6767906449167235/019d0227-4e4c-758e-934d-2169087524ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIxaUXSmWyFYRO41FlqZ7gfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e5c22ef3d77990a3b7a71b1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_098d66bc6394045a89d6aa0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4c50ac105e5a1a06370f3147",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "13:00"
    },
    {
      "id": "ec_91360a389953b7dec9fc99f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7ee7bc10315312d736ff0082",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_81bd6fc63e7a7956a0e76e64",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "rating": "5",
      "name": "Christopher Hasse",
      "text": "I just toured the Park Plaza at 201 E. 16th Ave. I had the pleasure of being shown an apartment by one Jordin Jackson. The apartment I saw was great. Lots of closet, space and a wonderful view of the mountains from the deck attached to the apartment. I liked the place enough to put in an application for residence there. What really pushed it over the top was Jordin herself. She was friendly, personable, knowledgeable, and professional. Everything a property manager should be. Weidner really hit a home run when they brought Jordin on board.",
      "date": "2025-05-01",
      "title": "false"
    },
    {
      "id": "ec_6a061ca312bfd7dc855ffc34",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "rating": "5",
      "name": "J Fults",
      "text": "We lived here for almost 3 years and loved it. They have since updated and the management staff is so kind and excellent customer service. Jordin is amazing! We only moved because we relocated out of state and when we needed some information from her recently for our new place, she was super responsive and gracious. We would definitely live here again, thank you Jordin and team for being so Awesome 😎",
      "date": "2025-04-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_58a27f65-01d1-4537-93de-c7db0b493d07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ed9-c42e-777d-8c42-b3bf805cb343.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03ed9-c42e-777d-8c42-b3bf805cb343",
        "storage_key": "property/6767906449167235/01a03ed9-c42e-777d-8c42-b3bf805cb343.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Park Plaza - 1Bed X 1 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ywd4dquc6Mp"
    },
    {
      "id": "custom_4522eb72-4ab2-49a3-9ad3-5780b2127d7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/01a03ed9-e381-74cb-89d2-94cc8abd2199.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03ed9-e381-74cb-89d2-94cc8abd2199",
        "storage_key": "property/6767906449167235/01a03ed9-e381-74cb-89d2-94cc8abd2199.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Park Plaza - 2Bed X 1Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1nHfSn8oQLQ"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0b0d0-7f1c-7583-9de5-eba97507d0f9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Park Plaza Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-with-walk-in-closets",
      "search_query": "apartments with walk-in closets in Anchorage",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Closets in Anchorage",
      "h2_subtitle": "Discover spacious living in Anchorage. Our apartments feature ample walk-in closets, offering both style and functionality.",
      "page_copy": "Experience comfortable city living with the luxury of space at Park Plaza, located in the vibrant South Addition neighborhood of Anchorage. Our smoke-free studio, one-, and two-bedroom apartments not only offer practical layouts but also come with the benefit of walk-in closets, providing ample storage for all your belongings. \n\nEnjoy seamless access to the downtown energy and the stunning Alaskan outdoors. With essential amenities like 24-hour emergency maintenance and easy intercom communication, Park Plaza ensures a convenient lifestyle. Explore our floor plans and see how our walk-in closets can complement your everyday living needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closets in Anchorage",
      "seo_description": "Find spacious Anchorage living at Park Plaza. Enjoy walk-in closets and convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-smoke-free-apartments-anchorage",
      "search_query": "smoke-free apartments Anchorage Municipality",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Anchorage Municipality",
      "h2_subtitle": "Embrace fresh air living in the heart of Anchorage Municipality. Our smoke-free apartments offer a healthy environment without compromising on comfort.",
      "page_copy": "Park Plaza presents a refreshing living experience in Anchorage Municipality with our smoke-free apartment community. Situated in the lively South Addition neighborhood, our complex offers studio, one-, and two-bedroom layouts designed for comfort and practicality. Enjoy city conveniences along with the benefits of a smoke-free environment that supports a clean, healthy lifestyle. \n\nOur residents enjoy amenities such as 24-hour emergency maintenance, laundry facilities, and seamless entry with our intercom system. Experience the blend of urban energy and Alaskan openness, all within a health-conscious, smoke-free setting at Park Plaza. Make the most of Anchorage's charm without the smoke.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in Anchorage Municipality",
      "seo_description": "Discover smoke-free living at Park Plaza in Anchorage Municipality. Enjoy a clean lifestyle with practical layouts and essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-with-dishwashers-south-addition",
      "search_query": "apartments with dishwashers in South Addition",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in South Addition",
      "h2_subtitle": "Enjoy convenient living with apartments in South Addition. Our homes come equipped with dishwashers and more.",
      "page_copy": "Located in the heart of Anchorage’s South Addition, Park Plaza offers modern apartments outfitted with comforts like dishwashers, enhancing your everyday convenience. Our smoke-free community includes studio, one-, and two-bedroom apartments, ideal for anyone looking to enjoy both city life and home comfort. \n\nPark Plaza combines practicality with convenience, featuring amenities such as laundry facilities, an intercom system, and 24-hour emergency maintenance. With a location that brings the best of Anchorage to your doorstep, our apartments provide not only essential kitchen conveniences but also a great neighborhood atmosphere. Discover efficient urban living with us at Park Plaza.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in South Addition",
      "seo_description": "Explore Park Plaza in South Addition, Anchorage. Our apartments offer dishwashers and more for comfortable living in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-balcony-apartments-anchorage-99501",
      "search_query": "balcony apartments in Anchorage 99501",
      "category": "Amenity",
      "h1_title": "Balcony Apartments in Anchorage 99501",
      "h2_subtitle": "Step outside onto your own balcony. Experience Anchorage living in our thoughtfully designed apartments in the 99501 area.",
      "page_copy": "Imagine enjoying Anchorage’s breathtaking views from your own balcony at Park Plaza, your next home base in the vibrant 99501 ZIP code. Our smoke-free studio, one-, and two-bedroom apartments are crafted for those who desire both urban excitement and a peaceful retreat. Balconies offer a personal outdoor space, perfect for relaxation or taking in the cityscape.\n\nIn addition to the balcony views, residents at Park Plaza benefit from amenities like 24-hour emergency maintenance, convenient laundry facilities, and an easy intercom system. Find the balance of tranquility and accessibility in the heart of Anchorage’s South Addition neighborhood with Park Plaza.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Balcony Apartments in Anchorage 99501",
      "seo_description": "Discover balcony apartments in Anchorage's 99501 at Park Plaza. Enjoy beautiful views and a convenient lifestyle in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-24-hour-maintenance-apartments-downtown-anchorage",
      "search_query": "24-hour maintenance apartments in downtown Anchorage",
      "category": "Amenity",
      "h1_title": "24-Hour Maintenance Apartments Downtown",
      "h2_subtitle": "Enjoy peace of mind with 24-hour maintenance in downtown Anchorage. Our apartments promise comfort and reliability around the clock.",
      "page_copy": "Located in the bustling heart of downtown Anchorage, Park Plaza offers peace of mind with our exceptional 24-hour emergency maintenance service. Whether you choose a cozy studio or a spacious two-bedroom, your home will be a worry-free zone thanks to prompt maintenance support ensuring everything runs smoothly.\n\nLiving at Park Plaza means enjoying not only a reliable service but also an array of convenient amenities such as laundry facilities and an intercom system. Our smoke-free apartments are designed to provide a practical yet comfortable lifestyle surrounded by the city's vibrant life, right here in the South Addition neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Maintenance Apartments Downtown",
      "seo_description": "Find 24-hour maintenance apartments at Park Plaza in downtown Anchorage. Enjoy round-the-clock reliability in the South Addition area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-studio-apartments-anchorage-ak",
      "search_query": "studio apartments Anchorage AK",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Anchorage, AK",
      "h2_subtitle": "Experience cozy living in the heart of Anchorage, AK. Our studio apartments offer comfort and convenience in a prime location.",
      "page_copy": "Located in Anchorage, AK, Park Plaza offers studio apartments that blend comfort and functionality. Designed for those who appreciate efficient living spaces, our studios provide a perfect mix of style and practicality in the bustling South Addition neighborhood. \n\nResidents of our well-maintained, smoke-free studio apartments can take advantage of amenities such as 24-hour emergency maintenance, convenient laundry facilities, and a reliable intercom system. Whether you're new to Anchorage or a long-time resident, you'll enjoy a convenient and cozy lifestyle at Park Plaza.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Anchorage, AK",
      "seo_description": "Discover studio apartments in Anchorage, AK at Park Plaza. Enjoy a cozy, convenient lifestyle in the South Addition neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-one-bedroom-apartments-south-addition",
      "search_query": "one bedroom apartments South Addition",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Addition",
      "h2_subtitle": "Discover spacious one bedroom apartments in South Addition. Park Plaza offers comfort and convenience in the heart of Anchorage.",
      "page_copy": "If you're searching for one bedroom apartments in South Addition, Park Plaza is your perfect match. Our thoughtfully designed one-bedroom units offer a blend of comfort and practicality, ideal for singles or couples who appreciate spacious living in a vibrant Anchorage neighborhood.\n\nResidents enjoy a smoke-free environment alongside amenities like 24-hour emergency maintenance, laundry facilities, and an efficient intercom system. Living at Park Plaza means enjoying the bustling city energy while having a peaceful retreat to call home in the heart of the South Addition community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Addition",
      "seo_description": "Find spacious one bedroom apartments in South Addition at Park Plaza. Experience comfort and convenience in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-two-bedroom-apartments-near-99501",
      "search_query": "two bedroom apartments near 99501",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 99501",
      "h2_subtitle": "Explore spacious two bedroom apartments conveniently located near the 99501 area. Park Plaza offers the perfect blend of comfort and convenience.",
      "page_copy": "Situated near the 99501 area, Park Plaza offers two bedroom apartments that cater to families and roommates seeking a comfortable city living experience. Our spacious layouts ensure that you have all the room you need while being right in the heart of Anchorage.\n\nAt Park Plaza, you'll enjoy modern amenities such as 24-hour emergency maintenance, laundry facilities, and a reliable intercom system. With our smoke-free environment and prime location in the South Addition neighborhood, your new two-bedroom home offers both peace of mind and convenient access to downtown's vibrant life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 99501",
      "seo_description": "Discover two bedroom apartments near 99501 at Park Plaza. Enjoy spacious living with modern amenities in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-near-central-middle-school-of-science",
      "search_query": "apartments near central middle school of science anchorage",
      "category": "School",
      "h1_title": "Apartments Near Central Middle School Anchorage",
      "h2_subtitle": "Discover comfortable apartments located near Central Middle School of Science in Anchorage. Park Plaza offers ideal living spaces for students and families.",
      "page_copy": "Park Plaza is conveniently situated near the Central Middle School of Science in Anchorage, making it an excellent choice for families and staff looking for a nearby residence. Our well-designed apartments provide a comfortable living space with easy access to educational opportunities and city life.\n\nFeaturing smoke-free living, reliable intercom facilities, and 24-hour emergency maintenance, Park Plaza ensures a peaceful and convenient lifestyle. Experience the energy of downtown Anchorage while enjoying the tranquility of the South Addition neighborhood, perfect for families seeking proximity to local schools and amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Central Middle School Anchorage",
      "seo_description": "Find apartments near Central Middle School of Science Anchorage at Park Plaza, offering a convenient lifestyle for families and educators.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-close-to-north-star-elementary",
      "search_query": "park plaza apartments close to north star elementary school",
      "category": "School",
      "h1_title": "Park Plaza Apartments Near North Star Elementary",
      "h2_subtitle": "Discover Park Plaza Apartments conveniently located close to North Star Elementary School, perfect for families valuing proximity to education.",
      "page_copy": "Nestled conveniently close to North Star Elementary School, Park Plaza Apartments offers families the ideal blend of comfort and location. Our various floor plans cater to families who value accessibility to quality education, making it easier for parents and children alike.\n\nAt Park Plaza, you’ll enjoy a smoke-free environment with amenities like 24-hour emergency maintenance and practical laundry facilities. Located in the serene South Addition neighborhood, Park Plaza provides a perfect home base for those seeking a balance of urban energy and a peaceful lifestyle in Anchorage.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Plaza Apartments Near North Star Elementary",
      "seo_description": "Find family-friendly apartments at Park Plaza, close to North Star Elementary School, offering convenience and comfort in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-nearby-apartments-west-anchorage-high-school",
      "search_query": "west anchorage high school nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to West Anchorage High School",
      "h2_subtitle": "Park Plaza offers convenient nearby apartments to West Anchorage High School, ideal for families and school personnel.",
      "page_copy": "Park Plaza provides an ideal home base with nearby apartments to West Anchorage High School. Perfect for families with students or school staff, our location ensures short commutes and easy access to educational facilities.\n\nEnjoy the benefits of living in our smoke-free community, complete with essential amenities like 24-hour emergency maintenance and intercom systems. Situated in the South Addition neighborhood of Anchorage, Park Plaza promises a harmonious balance of school proximity and the vibrant downtown lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to West Anchorage High School",
      "seo_description": "Discover Park Plaza's convenient apartments near West Anchorage High School, perfect for families and educators.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-near-university-of-alaska-anchorage",
      "search_query": "university of alaska anchorage area apartments",
      "category": "School",
      "h1_title": "UAA Area Apartments at Park Plaza",
      "h2_subtitle": "Explore Park Plaza, offering apartments conveniently located in the University of Alaska Anchorage area, ideal for students and faculty.",
      "page_copy": "Park Plaza offers exceptional living options for those seeking apartments in the University of Alaska Anchorage area. Our community caters to students and faculty alike, providing convenience and comfort with each floor plan.\n\nEnjoy amenities such as intercom access and reliable 24-hour emergency maintenance in a smoke-free environment. Located within the active South Addition neighborhood, Park Plaza places you close to both higher education and the buzzing downtown Anchorage, making it a top choice for academics and professionals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "UAA Area Apartments at Park Plaza",
      "seo_description": "Discover Park Plaza's convenient apartments near University of Alaska Anchorage, perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-near-alaska-pacific-university",
      "search_query": "apartments close to alaska pacific university",
      "category": "School",
      "h1_title": "Apartments Close to Alaska Pacific University",
      "h2_subtitle": "Park Plaza offers prime apartments close to Alaska Pacific University. Perfect for students seeking accessibility and comfort.",
      "page_copy": "Park Plaza presents an ideal living option for those seeking apartments close to Alaska Pacific University. Offering a range of studio, one-, and two-bedroom layouts, our community ensures a perfect home base with easy access to educational pursuits.\n\nResidents benefit from our smoke-free environment and practical amenities like laundry facilities and 24-hour access. Nestled in the South Addition neighborhood, Park Plaza not only connects you to the academic world but also provides a vibrant downtown Anchorage lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Alaska Pacific University",
      "seo_description": "Explore Park Plaza's convenient apartments near Alaska Pacific University, offering comfort and accessibility for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-near-dr-etheldra-davis-fairview-elementary",
      "search_query": "anchorage apartments near dr etheldra davis fairview elementary",
      "category": "School",
      "h1_title": "Apartments Near Dr. Etheldra Davis Fairview Elem",
      "h2_subtitle": "Discover convenient Anchorage apartments near Dr. Etheldra Davis Fairview Elementary for families seeking proximity to education and city life.",
      "page_copy": "For families prioritizing educational convenience, Park Plaza offers exceptional Anchorage apartments near Dr. Etheldra Davis Fairview Elementary. Our smoke-free community ensures an ideal setting for households with young school-going children.\n\nResidents enjoy easy access to essential amenities like 24-hour emergency maintenance and intercom systems, making Park Plaza both practical and appealing. Located in the vibrant South Addition neighborhood, you're placed in the heart of Anchorage's diverse offerings, from schools to cultural experiences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Dr. Etheldra Davis Fairview Elem",
      "seo_description": "Park Plaza provides Anchorage apartments conveniently located near Dr. Etheldra Davis Fairview Elementary, ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-near-government-hill-elementary",
      "search_query": "government hill elementary school nearby apartments anchorage",
      "category": "School",
      "h1_title": "Apartments Near Government Hill Elementary",
      "h2_subtitle": "Find Anchorage apartments near Government Hill Elementary, providing families with comfortable and accessible living options.",
      "page_copy": "Park Plaza stands out for families looking for Anchorage apartments near Government Hill Elementary School. With a choice of studio, one-, and two-bedroom apartments, our community meets the diverse needs of families valuing an educationally convenient location.\n\nExperience the benefits of essential amenities, including laundry facilities and a call box system, in a smoke-free environment. Located in the active South Addition neighborhood, Park Plaza ensures easy access to Anchorage's urban attractions and educational centers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Government Hill Elementary",
      "seo_description": "Check out Park Plaza's Anchorage apartments near Government Hill Elementary School, offering ideal living amenities for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-near-inlet-view-elementary",
      "search_query": "inlet view elementary school close by park plaza",
      "category": "School",
      "h1_title": "Close By Inlet View Elementary Apartments",
      "h2_subtitle": "Explore apartments close by Inlet View Elementary School at Park Plaza. Ideal for families prioritizing education and convenience.",
      "page_copy": "Park Plaza provides ideal living spaces for those seeking proximity to Inlet View Elementary School. Our smoke-free community offers studio, one-, and two-bedroom apartments tailored for families who value accessibility and ease.\n\nLocated within the vibrant South Addition neighborhood, Park Plaza places you within easy reach of the school, as well as Anchorage's dynamic city life. Residents enjoy amenities such as intercom systems and 24-hour emergency maintenance, ensuring safety and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close By Inlet View Elementary Apartments",
      "seo_description": "Discover Park Plaza apartments close by Inlet View Elementary School, offering family-friendly amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "anchorage-apartments-near-pacific-northern-academy",
      "search_query": "anchorage county apartments near pacific northern academy",
      "category": "School",
      "h1_title": "Apartments Near Pacific Northern Academy",
      "h2_subtitle": "Discover Anchorage County apartments near Pacific Northern Academy, perfect for families seeking educational convenience.",
      "page_copy": "Park Plaza offers families the perfect Anchorage County apartments situated near the esteemed Pacific Northern Academy. Our selection of studio, one-, and two-bedroom apartments caters to those who prioritize accessibility to quality education.\n\nIn our smoke-free environment, residents benefit from features like a reliable intercom system and 24-hour access. Nestled in the vibrant South Addition neighborhood, Park Plaza connects you effortlessly with both schooling options and the lively energy of Anchorage.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pacific Northern Academy",
      "seo_description": "Park Plaza provides Anchorage County apartments conveniently located near Pacific Northern Academy, ideal for families and students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center",
      "search_query": "apartments near Alaska Native Medical Center Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Explore Anchorage apartments near Alaska Native Medical Center. Park Plaza offers a convenient location for healthcare professionals.",
      "page_copy": "Park Plaza is a pivotal choice for healthcare professionals seeking apartments near Alaska Native Medical Center in Anchorage. Our community features studio, one-, and two-bedroom units designed for those who appreciate proximity to work and convenience.\n\nLocated in the bustling South Addition neighborhood, Park Plaza presents easy city access and essential amenities like 24-hour emergency maintenance, intercom systems, and laundry facilities, ensuring a stress-free living environment close to Anchorage's medical district.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Discover Park Plaza, offering Anchorage apartments conveniently near Alaska Native Medical Center, with amenities suitable for healthcare workers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "apartments-close-to-alaska-regional-hospital",
      "search_query": "apartments close to Alaska Regional Hospital South Addition",
      "category": "Hospital",
      "h1_title": "Close to Alaska Regional Hospital Apartments",
      "h2_subtitle": "Find South Addition apartments close to Alaska Regional Hospital at Park Plaza, ideal for medical staff and professionals.",
      "page_copy": "Park Plaza offers convenient living for those looking for apartments close to Alaska Regional Hospital in the South Addition area. Our community provides studio, one-, and two-bedroom options, perfect for medical professionals valuing easy commutes.\n\nSituated in the lively South Addition neighborhood, Park Plaza not only offers proximity to the hospital but also grants easy access to Anchorage's urban amenities. Enjoy features like 24-hour emergency maintenance and an intercom system, making your home life as streamlined and convenient as possible.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close to Alaska Regional Hospital Apartments",
      "seo_description": "Explore Park Plaza, offering South Addition apartments close to Alaska Regional Hospital with convenient amenities for professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "apartments-near-delaney-park",
      "search_query": "apartments near delaney park anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Delaney Park Anchorage",
      "h2_subtitle": "Discover attractive apartments near Delaney Park in Anchorage. Embrace city living with Park Plaza's ideal location.",
      "page_copy": "Experience the charm of living near one of Anchorage's iconic green spaces with Park Plaza's apartments near Delaney Park. Perfectly positioned in the city’s South Addition neighborhood, our community is a blend of modern conveniences and serene park-side living.\n\nChoose from studio, one-, and two-bedroom layouts, all smoke-free, with features aimed at enhancing daily life, including 24-hour access and laundry facilities. Enjoy the blend of easy access to green spaces and downtown activities, making Park Plaza an ideal home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Delaney Park Anchorage",
      "seo_description": "Find Park Plaza apartments near Delaney Park Anchorage, combining urban convenience with park-side living in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "park-plaza-apartments-close-to-buttress-park",
      "search_query": "park plaza apartments close to buttress park",
      "category": "Park",
      "h1_title": "Park Plaza Apartments Near Buttress Park",
      "h2_subtitle": "Discover Park Plaza apartments close to Buttress Park. Enjoy Anchorage living with a park-side advantage in South Addition.",
      "page_copy": "Park Plaza Apartments are ideally located near Buttress Park, offering the perfect mix of city life and nature. Situated in South Addition, residents enjoy access to Anchorage's vibrant atmosphere and the tranquility of nearby green spaces.\n\nChoose from our smoke-free studio, one-, and two-bedroom units, designed with comfort and convenience in mind. Amenities such as 24-hour emergency maintenance and an intercom system make Park Plaza an excellent choice for those who value proximity to outdoor recreation and urban amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park Plaza Apartments Near Buttress Park",
      "seo_description": "Explore Park Plaza, offering apartments close to Buttress Park with easy access to Anchorage amenities and nature in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "earthquake-park-nearby-living-anchorage",
      "search_query": "earthquake park nearby living anchorage",
      "category": "Park",
      "h1_title": "Living Near Earthquake Park in Anchorage",
      "h2_subtitle": "Explore nearby living options to Earthquake Park in Anchorage. Park Plaza offers a unique blend of city and park life convenience.",
      "page_copy": "For those seeking a harmonious blend of urban living and natural landscapes, Park Plaza offers an ideal choice with its proximity to Earthquake Park in Anchorage. Nestled in the South Addition neighborhood, our apartments provide easy access to one of Anchorage's most fascinating historical sites.\n\nOpt for our well-designed studio, one-, and two-bedroom apartments, each ensuring comfort and style. With amenities such as round-the-clock emergency maintenance and convenient laundry facilities, Park Plaza stands ready to offer a fulfilling apartment living experience near this scenic landmark.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Earthquake Park in Anchorage",
      "seo_description": "Discover Park Plaza for apartment living near Earthquake Park in Anchorage, blending city convenience with natural beauty in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "kincaid-park-access-south-addition-apartments",
      "search_query": "kincaid park access from south addition apartments",
      "category": "Park",
      "h1_title": "South Addition Apartments Near Kincaid Park",
      "h2_subtitle": "Enjoy easy Kincaid Park access from South Addition apartments. Park Plaza connects you with both nature and the city.",
      "page_copy": "For those who love the outdoors, Park Plaza offers apartments in Anchorage's South Addition with convenient access to Kincaid Park. This location combines the buzz of city life with the allure of natural escapes.\n\nChoose from our comfortable studio, one-, and two-bedroom layouts, all smoke-free and enhanced by modern amenities. Whether using our intercom system or enjoying 24-hour maintenance, Park Plaza ensures a pleasant living experience near one of Anchorage's favorite parks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Addition Apartments Near Kincaid Park",
      "seo_description": "Park Plaza Apartments offer easy access to Kincaid Park from South Addition, blending city living with outdoor adventure.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167235",
      "source": "generator",
      "page_item_url": "apartments-near-ted-stevens-anchorage-airport",
      "search_query": "apartments near Ted Stevens Anchorage International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Ted Stevens Anchorage Airport",
      "h2_subtitle": "Explore apartments conveniently located near Ted Stevens Anchorage International Airport. Experience ease of travel with Park Plaza.",
      "page_copy": "Park Plaza Apartments offer a strategic location for frequent flyers and aviation enthusiasts, situated conveniently near Ted Stevens Anchorage International Airport. Our South Addition community provides an excellent balance between city amenities and easy airport access.\n\nEnjoy living in smoke-free studio, one-, and two-bedroom units designed for comfort and practicality. With features like 24-hour emergency maintenance and secure intercom systems, Park Plaza ensures a seamless and enjoyable living experience right in the heart of Anchorage with direct access to travel convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and wall-mounted TV.",
        "public_id": "019d0226-7b84-718e-b034-1f6ea16d8f26",
        "storage_key": "property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ted Stevens Anchorage Airport",
      "seo_description": "Discover Park Plaza for convenient apartment living near Ted Stevens Anchorage International Airport in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309761877"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085397"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TR76BDM8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7295b03e-e9bd-4172-9901-67ee5eeb3539/app.js?property=7295b03e-e9bd-4172-9901-67ee5eeb3539&propertyName=Park+Plaza&channelUuid=c248fe01-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47710856320"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Inc3TjJlSEZsZVQzT0ZxTkVtWllPaEE9PSIsInZhbHVlIjoidFFTQS9yS3E2d0gzeHpwVmlPNm96Zz09IiwibWFjIjoiZjI3ZmE3NjRkNDU2YjY2ZTYxYjZmMzFkNTYyNzU4ZTI1YWM2NmVhZWIyMWI0N2M1MjMwNTIzZDZiMjM1ZDQ5NSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309761877",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085397",
  "custom_google_gtm_id": "GTM-TR76BDM8",
  "custom_rollout_phase": "Phase 7.2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7295b03e-e9bd-4172-9901-67ee5eeb3539/app.js?property=7295b03e-e9bd-4172-9901-67ee5eeb3539&propertyName=Park+Plaza&channelUuid=c248fe01-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47710856320",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Inc3TjJlSEZsZVQzT0ZxTkVtWllPaEE9PSIsInZhbHVlIjoidFFTQS9yS3E2d0gzeHpwVmlPNm96Zz09IiwibWFjIjoiZjI3ZmE3NjRkNDU2YjY2ZTYxYjZmMzFkNTYyNzU4ZTI1YWM2NmVhZWIyMWI0N2M1MjMwNTIzZDZiMjM1ZDQ5NSJ9",
  "custom_audioeye_site_id": "c60e581e-eb90-42f5-a90e-37515afd8d43",
  "custom_audioeye_site_hash": "dfb42fc1aaf5e5842ba1e5b697366e66"
};

export const generatedAt = '2026-10-29T23:13:49.143Z';
